import { render, staticRenderFns } from "./NormInfo.vue?vue&type=template&id=52876d24&scoped=true"
import script from "./NormInfo.vue?vue&type=script&lang=js"
export * from "./NormInfo.vue?vue&type=script&lang=js"
import style0 from "./NormInfo.vue?vue&type=style&index=0&id=52876d24&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52876d24",
  null
  
)

export default component.exports